import { Password, Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import React, { useState } from "react";

import {
  StyledFormControl,
  StyledFormControlTextArea,
  StyledLabel,
  StyledLabel2,
  StyledRequiredMark,
  StyledInput,
  StyledPasswordInput,
  StyledTextAreaInput,
  inputAdornmentSx,
  iconSx,
} from "./CustomInputs.styles";

export const CustomInput = ({
  mT,
  mB,
  type,
  placeholder,
  value,
  setValue,
  noIcon,
  Icon,
  rightIcon = false,
  width,
  bR,
  smallBr,
  label,
  label2,
  onClick,
  color,
  onKeyDown,
  min,
  max,
  limit = false,
  iconColor,
  required = false,
}) => {
  const handleChange = (e) => {
    let newValue = e.target.value;

    if (limit) {
      const numValue = parseInt(newValue, 10);
      if (numValue < min) newValue = min;
      if (numValue > max) newValue = max;
    }

    setValue(newValue);
  };

  return (
    <StyledFormControl fullWidth $mT={mT} $mB={mB}>
      {label && (
        <StyledLabel color={color}>
          {label}{" "}
          {required && (
            <StyledRequiredMark component="span">*</StyledRequiredMark>
          )}
        </StyledLabel>
      )}
      {label2 && <StyledLabel2>{label2}</StyledLabel2>}
      <StyledInput
        $width={width}
        $bR={bR}
        $color={color}
        onKeyDown={onKeyDown || null}
        type={type || "text"}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={handleChange}
        InputProps={{
          sx: { height: "50px" },
          startAdornment:
            !noIcon && !rightIcon && Icon ? (
              <InputAdornment position="start" sx={inputAdornmentSx}>
                <Icon sx={iconSx(iconColor)} />
              </InputAdornment>
            ) : null,
          endAdornment:
            !noIcon && rightIcon && Icon ? (
              <InputAdornment position="end" sx={inputAdornmentSx}>
                <IconButton
                  onClick={() => {
                    if (value) {
                      setValue("");
                      onClick?.();
                    }
                  }}
                >
                  <Icon sx={{ color: "#33261D", fontSize: "20px" }} />
                </IconButton>
              </InputAdornment>
            ) : null,
        }}
        InputLabelProps={{ shrink: false }}
      />
    </StyledFormControl>
  );
};

export const CustomPasswordInput = ({
  mT,
  mB,
  placeholder,
  value,
  setValue,
  width,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <StyledFormControl fullWidth $mT={mT} $mB={mB}>
      <StyledPasswordInput
        $width={width}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={(e) => setValue(e.target.value)}
        InputProps={{
          sx: { height: "50px" },
          startAdornment: (
            <InputAdornment position="start" sx={inputAdornmentSx}>
              <Password sx={iconSx()} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? (
                  <VisibilityOff sx={{ color: "#33261D" }} />
                ) : (
                  <Visibility sx={{ color: "#33261D" }} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: false }}
      />
    </StyledFormControl>
  );
};

export const CustomTextArea = ({
  mT,
  mB,
  placeholder,
  value,
  setValue,
  Icon,
  noIcon,
  width,
  label,
  rows,
  required = false,
}) => (
  <StyledFormControlTextArea fullWidth $mT={mT} $mB={mB}>
    <StyledLabel>
      {label}{" "}
      {required && <StyledRequiredMark component="span">*</StyledRequiredMark>}
    </StyledLabel>
    <StyledTextAreaInput
      $width={width}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={(e) => setValue(e.target.value)}
      multiline
      rows={rows || 4}
      InputProps={{
        sx: { height: "auto" },
        startAdornment:
          !noIcon && Icon ? (
            <InputAdornment position="start" sx={inputAdornmentSx}>
              <Icon sx={iconSx()} />
            </InputAdornment>
          ) : null,
      }}
      InputLabelProps={{ shrink: false }}
    />
  </StyledFormControlTextArea>
);
